export const css = {
	root: 'AuFwl-hY',
	instructorContainer: 'aWSp9htW',
	avatar: 'Cq7oh561',
	details: 'S5JNEzur',
	bio: 'W3yo1F7e',
	actionContainer: 'vKjyZPG1',
	userActions: 'Uj9uGCpZ',
	' _key': 'class-roster/instructor'
};

export default css;
